import { a as createCommonjsModule } from '../../../../common/_commonjsHelpers-8a10f9bf.js';

var policyRepresentation = createCommonjsModule(function (module, exports) {
exports.__esModule = true;
exports.Logic = exports.DecisionEffect = exports.DecisionStrategy = void 0;
(function (DecisionStrategy) {
    DecisionStrategy["AFFIRMATIVE"] = "AFFIRMATIVE";
    DecisionStrategy["UNANIMOUS"] = "UNANIMOUS";
    DecisionStrategy["CONSENSUS"] = "CONSENSUS";
})(exports.DecisionStrategy || (exports.DecisionStrategy = {}));
(function (DecisionEffect) {
    DecisionEffect["Permit"] = "PERMIT";
    DecisionEffect["Deny"] = "DENY";
})(exports.DecisionEffect || (exports.DecisionEffect = {}));
(function (Logic) {
    Logic["POSITIVE"] = "POSITIVE";
    Logic["NEGATIVE"] = "NEGATIVE";
})(exports.Logic || (exports.Logic = {}));

});

var DecisionEffect = policyRepresentation.DecisionEffect;
export { DecisionEffect };
